<div class="modal-container">
  <div class="modal-header">
    <h3 class="mat-h3">Create New ECR Data Folder</h3>
  </div>

  <div class="modal-content">
    <form class="form-field-full" [formGroup]="newFolderForm">
      <div class="form-inputs">
        <mat-form-field class="gingr-input-wrapper w-full">
          <input matInput placeholder="Folder name" type="text" formControlName="name" required />
        </mat-form-field>

        <mat-form-field class="gingr-input-wrapper w-full">
          <mat-select formControlName="status" placeholder="Select status">
            @for (st of statuses; track st) {
              <mat-option [value]="st">
                {{ st | titlecase }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>

    <div class="overflow-y-auto projects-container">
      <h3 class="mat-h3">Select RISE project</h3>
      @if (!isLoading) {
        <mat-radio-group (change)="selectProject($event)">
          @for (category of ECRProjectsCategories; track category) {
            <div class="m-t-24 category">
              {{ category.name }}
              @for (project of category.projects; track project) {
                <mat-radio-button [value]="project">{{ project.name }}</mat-radio-button>
              }
            </div>
          }
        </mat-radio-group>
      } @else {
        <div class="d-flex align-items-center justify-content-center">
          @if (isLoading) {
            <mat-progress-spinner
              class="spinner"
              [color]="'accent'"
              [mode]="'indeterminate'"
              [value]="50"
              >
            </mat-progress-spinner>
          }
        </div>
      }

    </div>
  </div>

  <div class="modal-footer">
    <div class="d-flex justify-content-between w-full">
      <button
        class="action-button"
        mat-raised-button
        color="accent"
        (click)="handleNextClick()"
        [disabled]="!selectedProject.id || newFolderForm.invalid"
        >
        Next
      </button>
      <button class="action-button" mat-stroked-button (click)="close()">Close</button>
    </div>
  </div>
</div>
